'use strict';

import appStore from '@uw-it-sis/lib-react/lib/AppStore';

class Api {
    constructor() {
        this.baseUrl = "api";
    }

    /**
     * Audit Listener processor and poller
     */
    getAuditListenerStatus() {
        return appStore.getHttpClient().doGet(`${this.baseUrl}/auditListener/status`, 'getAuditListenerStatus');
    }
    clearErrorsAuditListener() {
        return appStore.getHttpClient().doPost(`${this.baseUrl}/auditListener/needsAttention`, "false", 'clearErrorsAuditListener');
    }
    // poller
    pauseAuditListenerPoller() {
        return appStore.getHttpClient().doPost(`${this.baseUrl}/auditListener/poller/pause`, '', 'pauseAuditListenerPoller');
    }
    resumeAuditListenerPoller() {
        return appStore.getHttpClient().doPost(`${this.baseUrl}/auditListener/poller/resume`, '', 'resumeAuditListenerPoller');
    }

    // processor
    pauseAuditListenerProcessor() {
        return appStore.getHttpClient().doPost(`${this.baseUrl}/auditListener/processor/pause`, '', 'pauseAuditListenerProcessor');
    }
    resumeAuditListenerProcessor() {
        return appStore.getHttpClient().doPost(`${this.baseUrl}/auditListener/processor/resume`, '', 'resumeAuditListenerProcessor');
    }
    cleanupLockedRecord(syskey) {
        return appStore.getHttpClient().doDelete(`${this.baseUrl}/audit/locks/${syskey}`, '', 'cleanupLockedRecord');
    }

    getLockedSyskeys() {
        return appStore.getHttpClient().doGet(`${this.baseUrl}/audit/locks`, '', 'getLockedSyskeys');
    }
}

export default new Api();
